<template>
  <div>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-row>
        <v-col>
          <v-text-field
            :append-icon="oldPasswordInput ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="passwordRules"
            :type="oldPasswordInput ? 'text' : 'password'"
            name="oldPassword"
            label="รหัสผ่านเดิม *"
            v-model="oldPassword"
            @click:append="oldPasswordInput = !oldPasswordInput"
            outlined
            required
          ></v-text-field>
          <v-text-field
            :append-icon="firstPasswordInput ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="passwordRules"
            :type="firstPasswordInput ? 'text' : 'password'"
            name="firstPassword"
            label="รหัสผ่านใหม่ *"
            v-model="firstPassword"
            @click:append="firstPasswordInput = !firstPasswordInput"
            outlined
            required
          ></v-text-field>
          <v-text-field
            :append-icon="secondPasswordInput ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="secondPasswordRules"
            :type="secondPasswordInput ? 'text' : 'password'"
            name="secondPassword"
            label="ยืนยันรหัสผ่านใหม่ *"
            v-model="secondPassword"
            @click:append="secondPasswordInput = !secondPasswordInput"
            outlined
            required
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
    <save-alert :status="changePasswordStatus && (changePasswordStatus === 'success' ? 'success': 'error')"
                :error-text="alertText[changePasswordStatus]"
                success-text="เปลี่ยนรหัสผ่านสำเร็จ"></save-alert>
    <div class="tw-text-right">
      <v-btn color="black darken-1" text @click="closeDialog()">
        <v-icon left>mdi-close-circle-outline</v-icon>
        ยกเลิก
      </v-btn>
      <v-btn color="green darken-1" text @click="submit" :disabled="loading">
        <v-icon left>mdi-plus-circle-outline</v-icon>
        บันทึก
      </v-btn>
    </div>
  </div>
</template>

<script>

import {mapState} from "vuex";
import SaveAlert from "../save-alert"

export default {
  name: 'ResetPassword',
  props: ['closeDialog', 'dialog'],
  components: {
    SaveAlert
  },
  computed: mapState({
    changePasswordStatus: state => state.user.changePasswordStatus,
    loading: state => state.user.loading
  }),
  data() {
    return {
      valid: true,
      oldPasswordInput: false,
      firstPasswordInput: false,
      secondPasswordInput: false,
      oldPassword: "",
      firstPassword: "",
      secondPassword: "",
      passwordRules: [
        v => !!v || 'กรุณากรอกรหัสผ่าน',
        v => (v && v.length > 5) || 'รหัสผ่านควรมี 6 ตัวอักษร',
      ],
      secondPasswordRules: [
        v => !!v || 'กรุณากรอกรหัสผ่าน',
        v => (v && v === this.firstPassword) || 'รหัสผ่านไม่ตรงกัน',
        v => (v && v.length > 5) || 'รหัสผ่านควรมี 6 ตัวอักษร',
      ],
      alertText: {
        error: "เปลี่ยนรหัสผ่านไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
        authError: "รหัสผ่านเดิมไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง",
      },
    }
  },
  watch: {
    dialog: {
      handler: function () {
        if (this.dialog === false) {
          this.clearState()
          this.$store.dispatch('user/setChangePasswordStatus', {status: ""})
        }
      },
      deep: true
    },
    changePasswordStatus: {
      handler: function () {
        if (this.changePasswordStatus === "success") {
          this.clearState()
        }
      },
      deep: true
    },
  },
  methods: {
    submit: function () {
      this.$store.dispatch('user/setChangePasswordStatus', {status: ""})
      if (this.$refs.form.validate()) {
        this.$store.dispatch('user/checkPasswordAndResetPasswordUser', {
          oldPassword: this.oldPassword,
          newPassword: this.firstPassword
        })
      }
    },
    clearState: function () {
      this.oldPasswordInput = false
      this.firstPasswordInput = false
      this.secondPasswordInput = false
      this.oldPassword = ""
      this.firstPassword = ""
      this.secondPassword = ""
      this.valid = true
      this.$refs.form.resetValidation()
    },
  },
}
</script>
